import Button from "../../ui/Button/Button";
import HeroArt from "./HeroArt";
import ServiceIcon from "../../ui/ServiceIcon/ServiceIcon";
import styles from "./Hero.module.css";

export default function Hero() {
  return (
    <section id="home" className={styles.hero} aria-labelledby="hero-title">
      <div className={`container ${styles.inner}`}>
        <div className={styles.content}>
          <div className={styles.eyebrow}><span aria-hidden="true" /> YOUR LOCAL BUSINESS. NEXT LEVEL.</div>
          <h1 id="hero-title" className={styles.title}>
            Your business.<br />
            <span className={styles.accent}>Impossible</span><br />
            to miss.<span className={styles.titleArrow} aria-hidden="true">↗</span>
          </h1>
          <p className={styles.lead}>
            You’re great at what you do. Let’s make sure people know it.
            Standout websites, a stronger Google presence, and smarter tools for your everyday.
          </p>
          <div className={styles.actions}>
            <Button href="/contact" size="lg">
              Build my online presence <span aria-hidden="true">↗</span>
            </Button>
            <Button href="/our-clients" size="lg" variant="secondary">
              Explore the possibilities <span aria-hidden="true">→</span>
            </Button>
          </div>
          <div className={styles.assurances}>
            <span><Check /> Clear pricing</span>
            <span><Check /> Personal support</span>
            <span><Check /> Across India</span>
          </div>
        </div>
        <div className={styles.visual}>
          <div className={styles.visualNote}><span aria-hidden="true">✳</span> A big future starts<br />with being seen.</div>
          <HeroArt />
          <div className={styles.visualBadge}><span aria-hidden="true">↗</span><div>BUILT AROUND YOU<strong>Local roots. Limitless potential.</strong></div></div>
        </div>
      </div>
      <nav className={`container ${styles.heroFoot}`} aria-label="Explore our services">
        {[
          { icon: "website-builder", title: "Look your best online", text: "Websites that tell your story", href: "/our-clients" },
          { icon: "gbp", title: "Help customers find you", text: "Your presence on Google", href: "/services#service-gbp" },
          { icon: "patient-management", title: "Simplify your everyday", text: "Software for the way you work", href: "/products" },
        ].map(item => <a className={styles.serviceLink} href={item.href} key={item.icon}>
          <span className={styles.serviceIcon}><ServiceIcon id={item.icon} /></span>
          <span className={styles.serviceCopy}><strong>{item.title}</strong><span>{item.text}</span></span>
          <span className={styles.serviceArrow} aria-hidden="true">↗</span>
        </a>)}
      </nav>
    </section>
  );
}

function Check() {
  return <svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m5 10 3.5 3.5L15 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
